export { getEnterpriseConfig, enterpriseGetSetup } from './config';
